import { action, observable, computed, toJS } from "mobx";
import PagerStore from "./utility/PagerStore";
import {
  SORT_AMOUNT,
  SORT_CREATED,
  SORT_TERMINATED,
  SORT_ID,
  SORT_MACHINE,
  SORT_CLEANINGRATE,
  SORT_SUPPLIER,
  SORT_LOTNO,
  SORT_LOCATION,
  SORT_ITEM,
  SORT_QPURITY,
  SORT_QALIENSEED,
  SORT_QHARDSEED,
  SORT_QWATER,
} from "../Containers/Mix/Mixes";
import { formatDate } from "utility.js";

const STORE_MIXES = "mixes";

const SORT_ASC = "asc";
const SORT_DESC = "desc";

class MixesStore {
  pager;
  configStore;
  authStore;

  constructor(rawState = {}, configStore, authStore) {
    this.configStore = configStore;
    this.authStore = authStore;
    this.pager = new PagerStore(rawState.pager);

    if (rawState.items) {
      this.setItems(rawState.items);
    }
    if (rawState.search) {
      this.setSearch(rawState.search);
    }
    if (rawState.sortField) {
      this.setSortField(rawState.sortField);
    }
    if (rawState.sortDirection) {
      this.setSortDirection(rawState.sortDirection);
    }
    if (rawState.sealnums) {
      this.setSealnums(rawState.sealnums);
    }
  }
  toJS() {
    return {
      items: toJS(this.items),
      search: toJS(this.search),
      pager: toJS(this.pager),
      sortField: toJS(this.sortField),
      sortDirection: toJS(this.sortDirection),
      sealnums: toJS(this.sealnums),
    };
  }

  @observable items = [];
  @action setItems(value) {
    this.items = value.map((item) => {
      const name = this.configStore.items[item.ItemId];
      item.LotNo = parseInt(item.LotNo);
      item.QualityAlienseed =
        item.QualityAlienseed == -1.0 ? "Ny" : item.QualityAlienseed;
      item.ItemName =
        typeof name !== "undefined"
          ? name + (item.ItemRate ? " " + item.ItemRate : "")
          : "-";
      item.QuantityText =
        (item.BagType === 2
          ? item.BagCount + " x " + item.Quantity
          : item.Quantity) + " kg";
      item.MachineText =
        this.configStore.machines[item.MachineId].Name +
        (item.CleaningCount ? " x" + item.CleaningCount : "");
      item.CleaningRateText =
        this.configStore.cleaningRates[item.CleaningRate].split("-")[1];
      item.Supplier = this.configStore.suppliers[item.SupplierId];
      item.BinCodeText =
        item.BinCode + (item.Level != null ? "/" + item.Level : "");
      item.StatusText = this.configStore.palletstatuses[item.Status];
      item.Created = formatDate(item.Created);
      item.Terminated = item._Terminated ? formatDate(item._Terminated) : "";
      item.QualityFull = item.QualityFull ? JSON.parse(item.QualityFull) : null;
      item.FilterField = (
        item.LotNo +
        " " +
        (item.SealNum ? item.SealNum + " " : "") +
        item.MachineText +
        " " +
        (item.Dressing ? item.Dressing + " " : "") +
        item.Supplier +
        " " +
        (item.CustomSupplier ? item.CustomSupplier + " " : "") +
        item.ItemName +
        " " +
        (item.CustomItem ? item.CustomItem + " " : "") +
        this.configStore.cleaningRates[item.CleaningRate].split("-")[1] +
        " " +
        (item.CustomCleaningRate ? item.CustomCleaningRate + " " : "") +
        (item.BinCode
          ? item.BinCode + (item.Level != null ? "/" + item.Level : "") + " "
          : "") +
        item.Quantity +
        " " +
        item.Created +
        " " +
        (item.Terminated ? item.Terminated + " " : "")
      ).toLowerCase();
      return item;
    });
    this.pager.setItemCount(this.filteredItems.length);
  }

  @observable from;
  @action setFrom(value) {
    this.from = value;
  }
  @computed get fromFormatted() {
    return formatDate(this.from);
  }

  @observable to;
  @action setTo(value) {
    this.to = value;
  }
  @computed get toFormatted() {
    return formatDate(this.to);
  }

  @observable showTerminated = false;
  @action changeShowTerminated() {
    this.showTerminated = !this.showTerminated;
  }

  @observable searchtext = "";
  @action setSearchText(value) {
    this.searchtext = value;
  }

  @observable search = "";
  @action setSearch(value) {
    this.search = value;
    this.pager.setItemCount(this.filteredItems.length);
  }

  @observable sortField;
  @action setSortField(value) {
    this.sortField = value;
  }

  @observable sortDirection;
  @action setSortDirection(value) {
    this.sortDirection = value;
  }
  @action flipSortDirection() {
    this.sortDirection = this.sortDirection === SORT_ASC ? SORT_DESC : SORT_ASC;
  }

  @computed get filteredItems() {
    if (!this.search) {
      return this.items;
    }
    return observable(
      this.items.filter((item) => {
        const searches = this.search.split(" ");
        for (let i = 0; i < searches.length; i++) {
          const s = searches[i].toLowerCase();
          //console.log(s, item.FilterField)
          if (item.FilterField.indexOf(s) === -1) {
            return false;
          }
        }
        return true;

        for (let fieldValue of Object.values(item)) {
          if (("" + fieldValue).indexOf(this.search) > -1) {
            return true;
          }
        }
        return false;
      })
    );
  }

  @computed get sortedItems() {
    if (!this.sortDirection || !this.sortField) {
      return this.filteredItems;
    }
    const sortedItems =
      [
        SORT_MACHINE,
        SORT_CLEANINGRATE,
        SORT_SUPPLIER,
        SORT_LOCATION,
        SORT_ITEM,
        SORT_CREATED,
        SORT_TERMINATED,
      ].indexOf(this.sortField) > -1
        ? this.filteredItems.slice().sort((a, b) => {
            if (!a[this.sortField]) return -1;
            if (!b[this.sortField]) return 1;
            return a[this.sortField]
              ? a[this.sortField].localeCompare(b[this.sortField])
              : -1;
          })
        : this.filteredItems.slice().sort((a, b) => {
            const v1 = parseInt(a[this.sortField]);
            const v2 = parseInt(b[this.sortField]);
            if (v1 === v2) return 0;
            return v1 > v2 ? 1 : -1;
          });

    return observable(
      this.sortDirection === SORT_ASC ? sortedItems : sortedItems.reverse()
    );
  }

  @computed get shownItems() {
    return this.sortedItems.slice(
      this.pager.firstShownItem - 1,
      this.pager.lastShownItem
    );
  }

  @observable checked = [];
  @action setChecked(pallet, checked) {
    const index = this.checked.indexOf(pallet);
    if (index > -1 && !checked) {
      this.checked.splice(index, 1);
    } else if (index === -1 && checked) {
      this.checked.push(pallet);
    }
    console.log(pallet, checked, this.checked);
  }
  @action isChecked(pallet) {
    const index = this.checked.indexOf(pallet);
    if (index > -1) return true;
    return false;
  }
  @action resetCheckedPallets() {
    this.checked = [];
  }

  @observable selectedpallets = [];
  @action setSelectedPallets(value) {
    this.selectedpallets = value;
    console.log("selectedpallets:", value);
  }

  @observable mixedPallet;
  @observable mixedItems = [];
  @action setMixedPallet(value) {
    const name = this.configStore.items[value.Data.ItemId];
    value.Data.ItemName =
      typeof name !== "undefined"
        ? name + (value.Data.ItemRate ? " " + value.Data.ItemRate : "")
        : "-";
    value.Data.MachineText =
      this.configStore.machines[value.Data.MachineId].Name +
      (value.Data.CleaningCount ? " x" + value.Data.CleaningCount : "");
    value.Data.CleaningRateText =
      this.configStore.cleaningRates[value.Data.CleaningRate].split("-")[0];

    value.Data.SumQuantity = 0;
    for (const pallet of value.Pallets) {
      pallet.LotNo = parseInt(pallet.LotNo);
      pallet.QuantityText =
        (pallet.BagType === "SmallBag"
          ? pallet.BagCount + " x " + pallet.Quantity
          : pallet.Quantity) + " kg";
      pallet.Supplier = this.configStore.suppliers[pallet.SupplierId];
      const bin = this.configStore.bins.find((b) => b.id == pallet.BinId);
      pallet.BinCodeText = bin
        ? bin.name + (pallet.Level != null ? "/" + pallet.Level : "")
        : "-";
      pallet.StatusText = this.configStore.palletstatuses[pallet.Status];
      pallet.Created = formatDate(pallet.Created);
      pallet.Terminated = pallet._Terminated
        ? formatDate(pallet._Terminated)
        : "";
      pallet.SumQuantity = pallet.BagCount * pallet.Quantity;
      value.Data.SumQuantity += pallet.SumQuantity;
    }

    value.Data.QuantityText = value.Data.SumQuantity + " kg";

    this.mixedPallet = value;

    console.log(this.mixedPallet);

    this.mixedItems = value.MixedItems.map((mixeditem) => ({
      id: mixeditem.Id,
      item: this.configStore.itemsStructure.Subitems[mixeditem.ItemId].itemId,
      subitem: mixeditem.ItemId,
      sealnum: mixeditem.SealNum,
      cleaningrate: mixeditem.CleaningRateId,
      ratio: parseInt(mixeditem.Ratio),
      quantity: (
        (this.mixedPallet.Data.SumQuantity * mixeditem.Ratio) /
        100
      ).toFixed(1),
      deleted: false,
    }));
  }
  @action resetMixedPallet() {
    this.mixedItems = [];
    this.mixedPallet = null;
  }

  @action addMixedItem() {
    this.mixedItems.push({
      id: null,
      item: null,
      subitem: null,
      sealnum: "",
      cleaningrate: null,
      ratio: null,
      deleted: false,
      modified: null,
      user: this.authStore.user.Id,
    });
  }
  @action setMixedItem(index, prop, value) {
    this.mixedItems[index][prop] = value;
  }
  @action deleteMixedItem(index) {
    if (this.mixedItems[index].id) {
      this.mixedItems[index].deleted = true;
    } else {
      this.mixedItems.splice(index, 1);
    }
  }
  @action setMixedItemItem(idx, item) {
    if (this.mixedItems[idx].item !== item) {
      this.mixedItems[idx].item = item;
      this.mixedItems[idx].subitem = null;
      this.mixedItems[idx].modified = new Date();
    }
  }

  @action setMixedItemSubitem(idx, subitem) {
    this.mixedItems[idx].subitem = subitem;
    this.mixedItems[idx].modified = new Date();
  }

  @action setMixedItemSealnum(idx, sealnum) {
    this.mixedItems[idx].sealnum = sealnum;
    this.mixedItems[idx].modified = new Date();
  }
  @action setMixedItemCleaningRate(idx, cleaningrate) {
    this.mixedItems[idx].cleaningrate = cleaningrate;
    this.mixedItems[idx].modified = new Date();
  }

  @action setMixedItemRatio(idx, ratio) {
    if (isNaN(ratio)) return;
    ratio = parseInt(ratio);
    this.mixedItems[idx].ratio = ratio;
    this.mixedItems[idx].quantity = (
      (this.mixedPallet.Data.SumQuantity * ratio) /
      100
    ).toFixed(1);
    this.mixedItems[idx].modified = new Date();
  }
}

export { MixesStore, STORE_MIXES, SORT_ASC, SORT_DESC };
